import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpRequest, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SUPPRESS_ERROR_DIALOG } from './http-context.tokens';


@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(
    private router: Router
  ) { }


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // tslint:disable-next-line:one-variable-per-declaration
    let userData: any = localStorage.getItem(environment.storage.userData);
    if(userData) {
      userData = JSON.parse(userData)
    }

    // tslint:disable-next-line:prefer-const
    let httpHeaders: any = {};
    const isCoreApiRequest = request.url.startsWith(environment.api_url);

    if (userData) {
      if(environment.bypass_token) {
        httpHeaders.from_spec = '1'
        // httpHeaders.employee = '1'
      } else if(isCoreApiRequest) {
        if(userData?.authentication_token?.authentication_token) {
          httpHeaders['authentication-token'] = userData?.authentication_token?.authentication_token;
        }
      } else {
        httpHeaders.Authorization = `Bearer ${userData.authentication_token.access_token}`;
        if(userData?.authentication_token?.authentication_token) {
          httpHeaders.authentication_token = userData?.authentication_token?.authentication_token;
        }
        httpHeaders.employee = '1'
      }
     request = request.clone({
       url: request.url,
       setHeaders: httpHeaders
     });
   } else if(environment.bypass_token) {
      httpHeaders.from_spec = '1'
      // httpHeaders.employee = '1'
      request = request.clone({
        url: request.url,
        setHeaders: httpHeaders
      });
   }

   if(request.url.includes('employees')) {
      httpHeaders.from_spec = '1'
     request = request.clone({
       url: request.url,
       setHeaders: httpHeaders
     });
   }

    return next.handle(request).pipe(
      tap(
        // Succeeds when there is a response; ignore other events
        event => {
          // console.log(event)
        },
        // Operation failed; error is an HttpErrorResponse
        error => {
          console.log(error)
          if(error?.status == 401) {
            localStorage.removeItem(environment.storage.userData)
            this.router.navigate(['/auth']);
          } else if (!request.context.get(SUPPRESS_ERROR_DIALOG)) {
            this.showError(error);
          }
        }
      ),
      // Log when response observable either completes or errors
      finalize(() => {

      })
    );
  }

  showError(error: any){
    console.log(error)
    let html: any = ``;
    if(error.error.messages){
      html = `<p class="text-center">${error.error.messages.error_message}</p>`;
    }
    else{
      html = `<p class="text-center">${error.error}</p>`;
    }
    if(error.error && error.error.errors){
      let ul: any = `<ul class="mt-3">`
      Object.entries(error.error.errors).forEach(([key, value]) => {
        if(Array.isArray(value)){
          let li: any = `<li><p class="text-capitalize" style="font-size: 14px;"><strong>${key} :</strong></p>`;
          value.forEach(element => {
            li = li + `<p style="font-size: 14px;">${element}</p>`;
          });
          li = li + `</li>`
          ul = ul + li;
        }
        else if(value){
          let li: any = `<li><p><strong>${key} :</strong></p><p>${value}</p></li>`;
          ul = ul + li;
        }
      });
      ul = ul + `</ul>`;
      html = html + ul;
    }

    Swal.fire({
      icon: 'error',
      title: `${error?.status} - ${error?.statusText}`,
      html: html
    });
  }
}
